import Bilingual from './component';

export default Bilingual;
